// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.contacts-selector {
  height: 100%;
  width: 100%;
  background-color: rgb(242, 242, 242);
  display: flex;
  flex-direction: column;
  justify-content: flex-start;
  align-items: center;
}

.contacts-selector-controls {
  padding: 8px;
  width: calc(100% - 16px);
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  flex-shrink: 0;
}

.contacts-selector-search-container {
  height: auto;
  width: 100%;
  display: flex;
  flex-direction: column;
  gap: 8px;
}

.contacts-selector-invite-button {
  color: rgb(222, 72, 88);
  font-family: Roboto, sans-serif;
  font-size: 13px;
  font-weight: 500;
  cursor: pointer;
  display: flex;
  flex-direction: row;
  align-items: center;
  justify-content: flex-start;
  width: fit-content;
}

.contacts-selector-invite-button .material-icons {
  font-size: 18px;
  margin-right: 6px;
}

.contacts-selector-invite-button:disabled {
  cursor: not-allowed;
  opacity: 0.6;
}

.contacts-selector-instructions {
  margin: 8px 0;
  font-size: 12px;
  line-height: 18px;
  color: rgb(153, 153, 153);
  font-family: Roboto, Arial, sans-serif;
  width: 100%;
}

.contacts-selector-permissions {
  font-family: Roboto, Arial, sans-serif;
  color: rgb(222, 72, 88);
  font-size: 12px;
  width: 100%;
  font-weight: bold;
  margin-bottom: 8px;
}

.contacts-selector-limit-message {
  margin: 4px 0;
  padding: 6px 12px;
  font-size: 11px;
  line-height: 16px;
  color: var(--netsfere-red);
  background-color: color-mix(in srgb, var(--netsfere-red) 10%, transparent);
  border-radius: 3px;
  font-family: Roboto, Arial, sans-serif;
  text-align: center;
}

.contacts-selector-room-type {
  width: 100%;
  margin: 8px 0;
  padding: 8px 0;
  border-top: 1px solid rgb(224, 224, 224);
  border-bottom: 1px solid rgb(224, 224, 224);
}

.contacts-selector-list-container {
  flex: 1;
  width: 100%;
  overflow-y: auto;
}
`, "",{"version":3,"sources":["webpack://./src/components/Page/Conversations/ChatView/ContactsSelector.css"],"names":[],"mappings":"AAAA;EACE,YAAY;EACZ,WAAW;EACX,oCAAoC;EACpC,aAAa;EACb,sBAAsB;EACtB,2BAA2B;EAC3B,mBAAmB;AACrB;;AAEA;EACE,YAAY;EACZ,wBAAwB;EACxB,aAAa;EACb,sBAAsB;EACtB,uBAAuB;EACvB,mBAAmB;EACnB,cAAc;AAChB;;AAEA;EACE,YAAY;EACZ,WAAW;EACX,aAAa;EACb,sBAAsB;EACtB,QAAQ;AACV;;AAEA;EACE,uBAAuB;EACvB,+BAA+B;EAC/B,eAAe;EACf,gBAAgB;EAChB,eAAe;EACf,aAAa;EACb,mBAAmB;EACnB,mBAAmB;EACnB,2BAA2B;EAC3B,kBAAkB;AACpB;;AAEA;EACE,eAAe;EACf,iBAAiB;AACnB;;AAEA;EACE,mBAAmB;EACnB,YAAY;AACd;;AAEA;EACE,aAAa;EACb,eAAe;EACf,iBAAiB;EACjB,yBAAyB;EACzB,sCAAsC;EACtC,WAAW;AACb;;AAEA;EACE,sCAAsC;EACtC,uBAAuB;EACvB,eAAe;EACf,WAAW;EACX,iBAAiB;EACjB,kBAAkB;AACpB;;AAEA;EACE,aAAa;EACb,iBAAiB;EACjB,eAAe;EACf,iBAAiB;EACjB,0BAA0B;EAC1B,0EAA0E;EAC1E,kBAAkB;EAClB,sCAAsC;EACtC,kBAAkB;AACpB;;AAEA;EACE,WAAW;EACX,aAAa;EACb,cAAc;EACd,wCAAwC;EACxC,2CAA2C;AAC7C;;AAEA;EACE,OAAO;EACP,WAAW;EACX,gBAAgB;AAClB","sourcesContent":[".contacts-selector {\n  height: 100%;\n  width: 100%;\n  background-color: rgb(242, 242, 242);\n  display: flex;\n  flex-direction: column;\n  justify-content: flex-start;\n  align-items: center;\n}\n\n.contacts-selector-controls {\n  padding: 8px;\n  width: calc(100% - 16px);\n  display: flex;\n  flex-direction: column;\n  justify-content: center;\n  align-items: center;\n  flex-shrink: 0;\n}\n\n.contacts-selector-search-container {\n  height: auto;\n  width: 100%;\n  display: flex;\n  flex-direction: column;\n  gap: 8px;\n}\n\n.contacts-selector-invite-button {\n  color: rgb(222, 72, 88);\n  font-family: Roboto, sans-serif;\n  font-size: 13px;\n  font-weight: 500;\n  cursor: pointer;\n  display: flex;\n  flex-direction: row;\n  align-items: center;\n  justify-content: flex-start;\n  width: fit-content;\n}\n\n.contacts-selector-invite-button .material-icons {\n  font-size: 18px;\n  margin-right: 6px;\n}\n\n.contacts-selector-invite-button:disabled {\n  cursor: not-allowed;\n  opacity: 0.6;\n}\n\n.contacts-selector-instructions {\n  margin: 8px 0;\n  font-size: 12px;\n  line-height: 18px;\n  color: rgb(153, 153, 153);\n  font-family: Roboto, Arial, sans-serif;\n  width: 100%;\n}\n\n.contacts-selector-permissions {\n  font-family: Roboto, Arial, sans-serif;\n  color: rgb(222, 72, 88);\n  font-size: 12px;\n  width: 100%;\n  font-weight: bold;\n  margin-bottom: 8px;\n}\n\n.contacts-selector-limit-message {\n  margin: 4px 0;\n  padding: 6px 12px;\n  font-size: 11px;\n  line-height: 16px;\n  color: var(--netsfere-red);\n  background-color: color-mix(in srgb, var(--netsfere-red) 10%, transparent);\n  border-radius: 3px;\n  font-family: Roboto, Arial, sans-serif;\n  text-align: center;\n}\n\n.contacts-selector-room-type {\n  width: 100%;\n  margin: 8px 0;\n  padding: 8px 0;\n  border-top: 1px solid rgb(224, 224, 224);\n  border-bottom: 1px solid rgb(224, 224, 224);\n}\n\n.contacts-selector-list-container {\n  flex: 1;\n  width: 100%;\n  overflow-y: auto;\n}\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
